import { useId } from "react";

interface CustomFoodCreatorDashboardIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export function CustomFoodCreatorDashboardIcon({
  size = 36,
  color = "#094327",
  className,
}: CustomFoodCreatorDashboardIconProps) {
  const gradientId = useId().replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <g opacity="0.5">
        <path
          d="M0 18.367C0 14.2479 1.07288e-07 12.1883 0.93456 10.4809C1.86912 8.77358 3.57651 7.71392 6.99125 5.59463L10.5913 3.36037C14.2009 1.12012 16.0058 0 18 0C19.9942 0 21.7991 1.12012 25.4088 3.36037L29.0088 5.59462C32.4236 7.71392 34.1309 8.77358 35.0654 10.4809C36 12.1883 36 14.2479 36 18.367V21.105C36 28.1264 36 31.6373 33.8911 33.8186C31.7824 36 28.3882 36 21.6 36H14.4C7.61177 36 4.21767 36 2.10883 33.8186C2.14577e-07 31.6373 0 28.1264 0 21.105V18.367Z"
          fill={color}
        />
        <path
          d="M18 2C18.586 2 19.2271 2.1541 20.2236 2.63867C21.2612 3.14325 22.5147 3.9178 24.3545 5.05957L27.9541 7.29395C29.6942 8.37392 30.8765 9.11054 31.751 9.78027C32.5893 10.4223 33.023 10.9143 33.3115 11.4414C33.6018 11.9718 33.7894 12.6195 33.8916 13.707C33.9976 14.8352 34 16.2708 34 18.3672V21.1055C34 24.6706 33.9959 27.1505 33.7529 29.0195C33.5166 30.8376 33.0861 31.774 32.4531 32.4287C31.8293 33.074 30.9508 33.506 29.2246 33.7461C27.4337 33.9951 25.052 34 21.5996 34H14.4004C10.948 34 8.5663 33.9951 6.77539 33.7461C5.04929 33.506 4.17079 33.074 3.54688 32.4287C2.9139 31.774 2.48343 30.8376 2.24707 29.0195C2.00414 27.1505 2 24.6706 2 21.1055V18.3672C2 16.2708 2.00241 14.8352 2.1084 13.707C2.21059 12.6195 2.39825 11.9718 2.68848 11.4414C2.97699 10.9143 3.41072 10.4223 4.24902 9.78027C5.12355 9.11054 6.30577 8.37392 8.0459 7.29395L11.6455 5.05957C13.4852 3.9178 14.7388 3.14325 15.7764 2.63867C16.7729 2.15411 17.414 2 18 2Z"
          stroke={`url(#${gradientId})`}
          strokeOpacity="0.9"
          strokeWidth="4"
        />
      </g>
      <path
        d="M18 10C15.5 10 13.5 12 13.5 14.5C13.5 15.5 14 16.3 14.5 17H21.5C22 16.3 22.5 15.5 22.5 14.5C22.5 12 20.5 10 18 10Z"
        fill={color}
      />
      <path d="M14.5 17H21.5L22.5 20.5H13.5L14.5 17Z" fill={color} opacity="0.8" />
      <path
        d="M12.6 27.4502C11.8544 27.4502 11.25 28.0546 11.25 28.8002C11.25 29.5458 11.8544 30.1502 12.6 30.1502H23.4C24.1456 30.1502 24.75 29.5458 24.75 28.8002C24.75 28.0546 24.1456 27.4502 23.4 27.4502H12.6Z"
        fill={color}
      />
      <defs>
        <linearGradient id={gradientId} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FAFFFA" />
          <stop offset="1" stopColor="#FF3B30" />
        </linearGradient>
      </defs>
    </svg>
  );
}
